import React from 'react';
import { PricingRegion, REGION_LABELS } from '../../types/subscription';

interface BillingControlsProps {
  billingCycle: 'monthly' | 'annual';
  setBillingCycle: (cycle: 'monthly' | 'annual') => void;
  region: PricingRegion;
  setRegion: (region: PricingRegion) => void;
}

const BillingControls: React.FC<BillingControlsProps> = ({
  billingCycle,
  setBillingCycle,
  region,
  setRegion,
}) => {
  return (
    <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-6">
      {/* Billing Cycle Toggle */}
      <div className="flex items-center gap-4 bg-gray-100 dark:bg-slate-800 rounded-full p-1">
        <button
          onClick={() => setBillingCycle('monthly')}
          className={`px-6 py-2 rounded-full text-sm font-medium transition-colors ${
            billingCycle === 'monthly'
              ? 'bg-white dark:bg-slate-600 text-gray-900 dark:text-white shadow'
              : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white'
          }`}
        >
          Monthly
        </button>
        <button
          onClick={() => setBillingCycle('annual')}
          className={`px-6 py-2 rounded-full text-sm font-medium transition-colors ${
            billingCycle === 'annual'
              ? 'bg-white dark:bg-slate-600 text-gray-900 dark:text-white shadow'
              : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white'
          }`}
        >
          Annual
          <span className="ml-2 text-xs text-green-600 dark:text-green-400 font-semibold">Save 40%</span>
        </button>
      </div>

      {/* Region Selector */}
      <div className="flex items-center gap-2">
        <span className="text-sm text-gray-500 dark:text-gray-400">Region:</span>
        <select
          value={region}
          onChange={(e) => setRegion(e.target.value as PricingRegion)}
          className="border border-gray-200 dark:border-slate-600 bg-white dark:bg-slate-800 text-gray-900 dark:text-white rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        >
          {Object.entries(REGION_LABELS).map(([key, label]) => (
            <option key={key} value={key}>
              {label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default BillingControls;
